import { Persona } from './Persona'
import { MarketAnalysis } from './MarketAnalysis'

export interface AIPlanBlueprint {
  id: string
  organizationId: string
  accountId: string
  name: string
  companyName: string
  companyDomain: string
  employees?: number
  revenue?: number
  positioning?: string
  userProvidedInsights?: string
  status: AIPlanBlueprintStatus
  publicId?: string
  clientPreviewShowMarketAnalysis?: boolean | null
  clientPreviewShowPersonas?: boolean | null
  instantPlanIds?: string[]
  marketAnalysis: MarketAnalysis
  personas: Persona[]
  created: string
  createdBy: string
  updated: string
  updatedBy: string
  isHidden?: boolean
}

export enum AIPlanBlueprintStatus {
  Processing = 'Processing',
  Ready = 'Ready',
  Deleted = 'Deleted',
  Disapproved = 'Disapproved'
}
